export const downloadFileFromUrl = (url?: string | null) => {
  if (!url) return;

  const link = document.createElement("a");
  link.href = url;
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
};
